import type * as Types from '../../../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProviderPriceCalculationQueryVariables = Types.Exact<{
  startTime: Types.Scalars['ISO8601DateTime'];
  endTime: Types.Scalars['ISO8601DateTime'];
  numberOfGuests: Types.Scalars['Int'];
  id: Types.Scalars['ID'];
}>;


export type ProviderPriceCalculationQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id: string, priceCalculationItems?: Array<{ __typename?: 'OfferItem', name: string, description?: string | null, price: any, quantity: any, taxRate: any }> | null } | null };


export const ProviderPriceCalculationDocument = gql`
    query ProviderPriceCalculation($startTime: ISO8601DateTime!, $endTime: ISO8601DateTime!, $numberOfGuests: Int!, $id: ID!) {
  provider(id: $id) {
    id
    priceCalculationItems(
      endTime: $endTime
      numberOfGuests: $numberOfGuests
      startTime: $startTime
    ) {
      name
      description
      price
      quantity
      taxRate
    }
  }
}
    `;

/**
 * __useProviderPriceCalculationQuery__
 *
 * To run a query within a React component, call `useProviderPriceCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderPriceCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderPriceCalculationQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      numberOfGuests: // value for 'numberOfGuests'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderPriceCalculationQuery(baseOptions: Apollo.QueryHookOptions<ProviderPriceCalculationQuery, ProviderPriceCalculationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderPriceCalculationQuery, ProviderPriceCalculationQueryVariables>(ProviderPriceCalculationDocument, options);
      }
export function useProviderPriceCalculationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderPriceCalculationQuery, ProviderPriceCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderPriceCalculationQuery, ProviderPriceCalculationQueryVariables>(ProviderPriceCalculationDocument, options);
        }
export type ProviderPriceCalculationQueryHookResult = ReturnType<typeof useProviderPriceCalculationQuery>;
export type ProviderPriceCalculationLazyQueryHookResult = ReturnType<typeof useProviderPriceCalculationLazyQuery>;
export type ProviderPriceCalculationQueryResult = Apollo.QueryResult<ProviderPriceCalculationQuery, ProviderPriceCalculationQueryVariables>;